// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"4e677766","882":"4e677766"}[chunkId] + ".chunk.css";
};